import { ItemType, LevelType, ValidItemsType } from 'data/types';

export type FoundationTypeType = 'basement' | 'crawlspace' | 'none';

export function isFoundationLevel(level: LevelType | undefined): boolean {
  return level?.type === 'basement' || level?.type === 'crawlspace';
}

const VERTICAL_LEVEL_TYPE_ORDER: Record<string, number> = {
  basement: 0,
  crawlspace: 1,
  level: 2,
  attic: 3
};

export function sortLevelsByVerticalPosition(
  structure: LevelType[]
): LevelType[] {
  return structure
    .map((level, index) => ({ level, index }))
    .sort((a, b) => {
      const orderA =
        VERTICAL_LEVEL_TYPE_ORDER[a.level.type] ??
        VERTICAL_LEVEL_TYPE_ORDER.level;
      const orderB =
        VERTICAL_LEVEL_TYPE_ORDER[b.level.type] ??
        VERTICAL_LEVEL_TYPE_ORDER.level;
      return orderA !== orderB ? orderA - orderB : a.index - b.index;
    })
    .map(({ level }) => level);
}

export function getLevelCount(structure: LevelType[]): number {
  return structure.filter((level) => level.type === 'level').length;
}

export function getFoundationType(structure: LevelType[]): FoundationTypeType {
  if (structure.some((level) => level.type === 'basement')) {
    return 'basement';
  }
  if (structure.some((level) => level.type === 'crawlspace')) {
    return 'crawlspace';
  }
  return 'none';
}

export function getHasAttic(structure: LevelType[]): boolean {
  return structure.some((level) => level.type === 'attic');
}

export function getValidLevelCodes(
  items: ItemType[],
  validItems: ValidItemsType[],
  structureSubtypeId: number | null
): string[] {
  const validItemIds =
    validItems.find((vi) => vi.structureSubtypeId === structureSubtypeId)
      ?.itemIds ?? [];

  return items
    .filter(
      (item) =>
        item.group === 'Level' &&
        (validItemIds.length === 0 || validItemIds.includes(item.id))
    )
    .map((item) => item.code);
}
